import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams  } from 'react-router-dom';
import Typography from '@mui/material/Typography'; 
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { mapAction } from '../../redux/actions/mapAction';
import config from '../../configs';
import { Loader } from "../../errorPages/Loader";


export default function MapView() {
    const [statuss, setStatuss] = useState(false);
    const [images, setImages] = React.useState([]);
    const [data, setData] = React.useState([]);
    const dispatch = useDispatch();
    const { id } = useParams();
    const handleStatusChange = (event) => {
        setStatuss(event.target.value);
    };

    useEffect(() => { 
        dispatch(mapAction.edit(id)); 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    const {mapData , mapData_status , loading } = useSelector(state => state.maps);   

    useEffect(() => { 
        if(mapData_status === true){
            setData(mapData);
        }
    }, [mapData_status, mapData])


    useEffect(() => { 
        if(data && data!==undefined && data !== ""){
            if(data.status !== undefined ){
                setStatuss(data.status);
            }
            if((data.imagePath && data.imagePath !== undefined) ){
                let arrValue = [];
                let arrObject = {
                    path: data.imagePath
                }   
                arrValue.push(arrObject)
                setImages(arrValue);                    
            }
        }
    }, [data])

    console.log(images)
  
  return (
    <Box sx={{ mb:3 }} className='cardWrapper'>
        {loading ? <Loader/> : '' }
         <div className="pageTitleWrap">
            <Stack  direction="row" spacing={1}   alignItems="center">
                <Typography type="submit" variant="text" component={Link} to={"/stadium-map"} > Stadium Map</Typography>
                <Typography className="" component={"h2"} variant="h2" >
                    / View Stadium
                </Typography>
            </Stack>
        </div>
        <Formik
            initialValues={{
                stadiumName : (data && data.stadiumName) ? data.stadiumName : '',
                status: statuss,
            }}
            enableReinitialize
            onSubmit={(values, {setErrors, setSubmitting}) => {  
            }}>
            {({ errors, touched, values, handleChange, handleBlur, handleSubmit, handleReset, isSubmitting }) => (
            <form onSubmit={handleSubmit}> 
             <Card sx={{ pb:"0px !important"}} variant="outlined" className="formWrapper">
                 <CardHeader title="View"/>
                 <CardContent > 
                     <Grid container spacing={2} alignItems="stretch">
                         <Grid item lg={5} xl={5} sx={{pr:5}}>
                             <TextField
                                 error={errors.stadiumName && touched.stadiumName}
                                 label="Stadium Name"
                                 fullWidth 
                                 name="stadiumName"
                                 value={values.stadiumName}
                                 onChange={handleChange}
                                 onBlur={handleBlur}
                                 helperText={(errors.stadiumName && touched.stadiumName) && errors.stadiumName}
                                 margin="normal"
                                 variant="outlined"
                                 disabled
                             />
                             <FormControl sx={{mt:2, width:"100%", textAlign:"left"}}>
                                 <FormLabel id="demo-row-radio-buttons-group-label">Status</FormLabel>
                                 <RadioGroup
                                     row
                                     aria-labelledby="demo-row-radio-buttons-group-label"
                                     name="status"
                                     value={statuss}
                                     onChange={(event) => {
                                         handleChange(event);
                                         handleStatusChange(event); 
                                     }}
                                 >
                                     <FormControlLabel disabled value={true} control={<Radio />} label="Active" />
                                     <FormControlLabel disabled value={false} control={<Radio />} label="Inactive" />
                                 </RadioGroup>
                             </FormControl>
                         </Grid>
                     
                         <Grid item lg={7} xl={7} sx={{}} >
                             
                         <div className="upload__image-wrapper">
                                    <Card sx={{height:"95%", border:"1px solid rgba(20,20,20,0.2)", minHeight:"250px", maxHeight:"250px", display:"flex", justifyContent:"center", alignItems:"center"}} elevation={0}>
                                 {images && images.length > 0 ?
                                     images.map((image, index) => (
                                         <div key={index} className="image-item">

                                     <CardMedia
                                         component="img"
                                         height="100%"
                                         image={image.path ? config.apiBaseUrl+'/'+image.path : image.data_url}
                                         alt="green iguana"
                                     />
                                             <div className="image-item__btn-wrapper">
                                             </div>
                                         </div>
                                     ))
                                     :
                                     <CardContent sx={{p:"0 !important", height:"100%"}}>
                                         <Box >
                                              <span className='upload_icon'><i className='icon-upload'></i></span>
                                             <span className='upload_content'>Upload Banner Image</span>
                                         </Box>
                                     </CardContent>
                                     }
                                  </Card>
                                 <Stack className='upload__helpText' direction="row" spacing={2} justifyContent="space-between"  alignItems="center">
                                     <Typography  variant="body1" component="p" >
                                         File Size: Max 5 Mb
                                     </Typography>
                                     <Typography  variant="body1" component="p" >
                                         File Format: .jpeg .jpg .png .bmp 
                                     </Typography>
                                 </Stack>
                               
                             </div>
                         </Grid>
                     </Grid> 
                 </CardContent>              
             </Card>  
            </form>
            )}
        </Formik>    
    </Box>
  )
}
